<!-- ALERT & CONFIRM DIALOG -->
<p-toast></p-toast>
<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>

<div class="card">

    <!-- TOOLBAR -->
    <p-toolbar styleClass="p-mb-4">
        <ng-template pTemplate="left">
            <button pButton pRipple label="{{lbl_go_Back}}" icon="pi pi-chevron-left" class="p-button-warning p-mr-2"
                (click)="goBack()"></button>
        </ng-template>
    </p-toolbar>

    <!-- MAIN CONTENT -->
    <div class="p-grid">
        <div class="p-col-12 p-md-6">
            <p-panel>
                <div class="p-grid">
                    <!-- INFO -->
                    <div class="p-col-12">
                        <!-- INPUT -->
                        <div class="p-formgrid p-grid p-ai-center p-jc-between p-pt-1 p-py-1">
                            <div class="subTitle p-col-12 p-md-4">
                                <span>Coordinación</span>
                            </div>
                            <div class="p-col-12 p-md-8">
                                <input style="width: 100%;" id="coordinationSelectedId"
                                    [(ngModel)]="coordinationSelected" type="text" maxlength="30" pInputText
                                    disabled="true">
                            </div>
                        </div>

                        <!-- INPUT -->
                        <div class="p-formgrid p-grid p-ai-center p-jc-between p-pt-1 p-py-1">
                            <div class="subTitle p-col-12 p-md-4">
                                <span>Año</span>
                            </div>
                            <div class="p-col-12 p-md-8">
                                <p-inputNumber styleClass="input-styling" id="yearSelectedId" [(ngModel)]="yearSelected"
                                    inputId="withoutgrouping" [useGrouping]="false" [showButtons]="true"
                                    [min]="yearActual-4" [max]="yearActual+5"
                                    (onInput)="loadWorkShopMng()"></p-inputNumber>
                            </div>
                        </div>

                        <!-- INPUT -->
                        <div class="p-formgrid p-grid p-ai-center p-jc-between p-pt-1 p-py-1">
                            <div class="subTitle p-col-12 p-md-4">
                                <span>Periodo</span>
                            </div>
                            <div class="p-col-12 p-md-8">
                                <p-inputNumber styleClass="input-styling" id="periodSelectedId"
                                    [(ngModel)]="periodSelected" inputId="withoutgrouping" [useGrouping]="false"
                                    [showButtons]="true" [min]="1" [max]="2"
                                    (onInput)="loadWorkShopMng()"></p-inputNumber>
                            </div>
                        </div>
                    </div>
                </div>
            </p-panel>
        </div>
    </div>

    <!-- PARTICIPANT LIST -->
    <p-table #dt [value]="workshopLgcList" [rows]="10" [paginator]="true" [columns]="lstCols"
        [globalFilterFields]="['gui.guideId','guiScr.guiType','gui.name','wst.wsName','f0.status']"
        [(selection)]="workshopLgcSelected" [rowHover]="true" dataKey="particiId"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [showCurrentPageReport]="true"
        responsive="true">

        <ng-template pTemplate="caption">
            <div class="p-d-flex p-ai-left p-jc-between">
                <h5 class="p-md-6">Servicios en curso</h5>
                <span class="p-input-icon-left">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')"
                        placeholder="{{lbl_search}}..." />
                </span>
            </div>

            <span class="p-input-icon-left">
                <button type="button" pButton pRipple icon="pi pi-file-excel" (click)="exportExcel()"
                    class="p-button-success p-mr-2 z-5" pTooltip="XLS" tooltipPosition="bottom"></button>

                <button type="button" pButton pRipple icon="pi pi-file-pdf" (click)="exportPdf()"
                    class="p-button-warning p-mr-2" pTooltip="PDF" tooltipPosition="bottom"></button>
            </span>

        </ng-template>
        <ng-template pTemplate="header">
            <tr>
                <th pSortableColumn="gui.guideId">ID<p-sortIcon field="gui.guideId"></p-sortIcon></th>
                <th pSortableColumn="guiScr.guiType">Tipo<p-sortIcon field="guiScr.guiType"></p-sortIcon></th>
                <th pSortableColumn="gui.name">Nombre<p-sortIcon field="gui.name"></p-sortIcon></th>
                <th pSortableColumn="wst.wsName">Servicio<p-sortIcon field="wst.wsName"></p-sortIcon>
                </th>
                <th pSortableColumn="f0.status">Estatus<p-sortIcon field="f0.status"></p-sortIcon></th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-data>
            <tr>
                <td>{{data.gui.guideId ? data.gui.guideId : 'S/N'}} </td>
                <td>{{data.guiScr.guiType ? data.guiScr.guiType : 'S/N'}} </td>
                <td>{{data.gui.name}} {{data.gui.lastName}}</td>
                <td>{{data.wst ? data.wst.wsName : 'Sin Servicio' }}</td>
                <td>{{data.f0 ? data.f0.status : 'S/N' }}</td>
            </tr>
        </ng-template>
        <ng-template pTemplate="summary">
            <div class="p-d-flex p-ai-center p-jc-between">
                In total there are {{workshopMngList ? workshopMngList.length : 0 }} workshop mng.
            </div>
        </ng-template>
    </p-table>
</div>